import styled from 'styled-components';
import { DataDisplayGroup } from 'components/molecules';

export const StyledCoinSentiment = styled(DataDisplayGroup)``;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
